
import { defineComponent, reactive } from 'vue';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import { IDadosLogin } from '../models/IDadosLogin';
import { IDTOEmpresaUsuario } from '@/models/DTO/MeuSistema/Autenticacao/IDTOEmpresaUsuario';
import GerenteAutenticacao from '../gerentes/GerenteAutenticacao';
import QuadroLogin from './QuadroLogin.vue';
import storeSistema from '@/store/storeSistema';
import router from '@/router';
import CampoSenha from '../components/Tela/CampoSenha.vue';
import Icone from '../components/Icone.vue';

export default defineComponent({
  name: 'Login',
  components: {
    QuadroLogin,
    Icone,
    CampoSenha,
  },
  setup() {
    const gerenteAutenticacao = new GerenteAutenticacao();

    if (gerenteAutenticacao.existeToken()) {
      router.push({ name: 'MinhaDashboard' });
    }
    const state = reactive({
      dadosLogin: {} as IDadosLogin,
      mensagemAlerta: '',
      empresasVinculadas: [] as IDTOEmpresaUsuario[],
      exibirSelecaoEmpresa: false,
      carregandoEmpresas: false,
      exibirCampoParceiro: false,
      emailBuscado: '',
    });

    async function buscarEmpresasEmail() {
      const email = state.dadosLogin.login?.trim().toLowerCase();

      // Evitar buscas duplicadas para o mesmo e-mail
      if (!email || !email.includes('@') || email === state.emailBuscado) {
        return;
      }

      state.emailBuscado = email;
      state.carregandoEmpresas = true;
      state.mensagemAlerta = '';
      state.exibirCampoParceiro = false;

      try {
        const empresas = await new ServicoSistema().obterEmpresasPorEmail(email);

        if (empresas.length === 0) {
          // Nenhuma empresa encontrada - pode ser usuário inexistente ou sem empresas
          // Não mostrar erro aqui, deixar o usuário tentar fazer login
          state.empresasVinculadas = [];
        } else {
          // Uma ou múltiplas empresas: selecionar automaticamente a primeira empresa
          state.dadosLogin.chaveParceiro = empresas[0].codigoEmpresa.toString();
          state.empresasVinculadas = empresas;
          // Não exibir mais o modal de seleção para múltiplas empresas
          state.exibirSelecaoEmpresa = false;
        }
      } catch (error) {
        // Silencioso - não mostrar erro para não expor se usuário existe
        state.empresasVinculadas = [];
      } finally {
        state.carregandoEmpresas = false;
      }
    }

    function selecionarEmpresa(empresa: IDTOEmpresaUsuario) {
      state.dadosLogin.chaveParceiro = empresa.codigoEmpresa.toString();
      state.exibirSelecaoEmpresa = false;
    }

    function formatarCNPJ(cnpj: string): string {
      if (!cnpj) return '';
      // Remover caracteres não numéricos
      const numeros = cnpj.replace(/\D/g, '');
      if (numeros.length !== 14) return cnpj;
      return numeros.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }

    async function efetuarLogin() {
      if (!state.dadosLogin.login) {
        state.mensagemAlerta = 'Informe o seu usuário ou e-mail!';
        return;
      }
      if (!state.dadosLogin.senha) {
        state.mensagemAlerta = 'Por favor, digite a sua senha!';
        return;
      }
      if (state.exibirCampoParceiro && !state.dadosLogin.chaveParceiro) {
        state.mensagemAlerta = 'Para usuários Admin/Suporte, a chave do parceiro é obrigatória.';
        return;
      }

      try {
        const retornoAutenticacao = await new ServicoSistema().login(state.dadosLogin);
        if (retornoAutenticacao.autenticado) {
          gerenteAutenticacao.salvarDadosAutenticacao(retornoAutenticacao.token, retornoAutenticacao.dataExpiracao.toString(), state.dadosLogin.chaveParceiro);
          router.push({ name: 'MinhaDashboard' });
        } else {
          state.mensagemAlerta = retornoAutenticacao.mensagem;
        }
      } catch (error) {
        state.mensagemAlerta = 'Desculpe-nos não conseguimos realizar o login no momento.';
      }
    }

    function redefinirSenha() {
      router.push({ name: 'EsqueciMinhaSenha' });
    }

    return {
      state,
      storeSistema,
      efetuarLogin,
      buscarEmpresasEmail,
      selecionarEmpresa,
      formatarCNPJ,
      redefinirSenha,
    };
  },
});
